import { Component,  Input, EventEmitter, Output } from '@angular/core';
import { Performer } from '../../../../globals/store/performers.data';
import { Sponsor } from '../../../../globals/store/sponsors.data';
import { WFWorker } from '../../../../globals/store/workforce.data';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { JoiResource } from '../../../../globals/store/resources.data';
import publicHelpers from '../../../../globals/helpers/public-helpers';
import { IconComponent } from '../icon/icon.component';
import { PhotoComponent } from '../photo';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'menu-hover-button',
    template: `
<div class="hover-button smooth" [ngClass]="{warn: warn, noBackground: noBackground, readOnly: readOnly}" >
  <div 
    *ngIf="!!hoverText"
    class="tooltip smooth"
    [ngStyle]="{ width: width, transform: !tooltipLeft && !tooltipRight && !customTransform ? 'translateX(-50%)' : customTransform ? customTransform : 'unset' }" 
    [ngClass]="{noWrap: noWrap, left: tooltipLeft, center: !tooltipLeft && !tooltipRight && !customTransform, right: tooltipRight }"
  >{{ hoverText }}</div>
  <div class="icon-text" *ngIf="!!text || !!iconSelector || !!worker || !!entity" (click)="buttonClick.emit($event)">
    <icon *ngIf="!!iconSelector" [icon]="iconSelector" [i12]="i12" [i18]="i18" ></icon>
    <photo *ngIf="!!worker" [size]="24" [data]="worker"></photo>
    <photo *ngIf="!!entity" [size]="24" [data]="{ title: entity.name || '?' }"></photo>
    <div *ngIf="!!text" class="text" [ngClass]="{lightText: lightText, desktop: !mobileText }" [innerHTML]="helpers.strWithBreak(text)"></div>
  </div>
  <ng-content></ng-content>
  <ng-container *ngIf="!hideMenu"><ng-content select=".hover-menu"></ng-content></ng-container>
  <div class="progress-bar" *ngIf="!!progress || progress === 0" [ngStyle]="{width: min(progress, 100) + '%'}" [ngClass]="{done: progress > 90, colored: progress < 100.01}"></div>
</div>
`,
    styleUrls: ['./menu-hover-button.sass'],
    standalone: true,
    imports: [IconComponent, MatButtonModule, PhotoComponent, CommonModule],
})

export class MenuHoverButtonComponent {
  @Input() i12 = false
  @Input() i18 = false
  @Input() noWrap = true
  @Input() customTransform = null
  @Input() width = 'unset'
  @Input() hoverText
  @Input() lightText = false
  @Input() text
  @Input() mobileText = false
  @Input() iconSelector
  @Input() progress
  @Input() readOnly = false
  @Input() warn = false
  @Input() worker: WFWorker
  @Input() entity: Performer | Sponsor | Exhibitor | JoiResource
  @Input() noBackground = false
  @Input() tooltipLeft = false
  @Input() tooltipRight = false
  @Output() buttonClick: EventEmitter<MouseEvent> = new EventEmitter()
  hideMenu = false
  min = Math.min
  helpers = publicHelpers

  hideMenuForMS(ms: number) {
    this.hideMenu = true
    setTimeout(() => this.hideMenu = false, ms)
  }


}

